import { Widget } from "blue-widgets";

class CardTruncate extends Widget {
  constructor(el) {
    super(el);
    this.title = el.querySelector("[data-title]");
    this.body = el.querySelector("[data-body]");
    this.maxBodyLines = JSON.parse(this.el.getAttribute("data-max-body-lines"));

    window.addEventListener("resize", () => {
      setTimeout(() => {
        this.setLineClamp();
      }, 500);
    });

    this.setLineClamp();
  }

  setLineClamp = () => {
    if (!this.title || !this.body) return;
    this.computedStyle = window.getComputedStyle(this.title);
    this.titleHeight = this.title.offsetHeight;
    this.titleLineHeight = parseFloat(
      this.computedStyle.getPropertyValue("line-height")
    );

    // number of lines the title spans
    this.titleLines = Math.floor(this.titleHeight / this.titleLineHeight);

    // If the title spans more than one line,
    // truncate the body to 2 lines instead of the default 3
    if (this.titleLines > 1 || this.maxBodyLines === 2) {
      this.body.style.webkitLineClamp = 2;
    } else {
      this.body.style = "";
    }

    // For cards with a max of 2 body lines, set the body to 1 line if the title spans 2 lines
    if (this.maxBodyLines === 2 && this.titleLines > 1) {
      this.body.style.webkitLineClamp = 1;
    }
  };

  beforeRemove() {
    window.removeEventListener("resize", this.setLineClamp);
  }
}

export default CardTruncate;
